import {configureStore as createReduxStore} from '@reduxjs/toolkit';
import rootReducer from '../rootReducers/mobile.homePageReducer';
import searchQueryTracker from '../middleware/searchQueryTracker';

export default function configureStore(initialState) {
  return createReduxStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(searchQueryTracker),
  });
}
